'use strict';

exports.__esModule = true;
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Element2 = require('./Element');

var _Element3 = _interopRequireDefault(_Element2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var If = (_temp = _class = function (_Element) {
  (0, _inherits3.default)(If, _Element);

  function If() {
    (0, _classCallCheck3.default)(this, If);
    return (0, _possibleConstructorReturn3.default)(this, _Element.apply(this, arguments));
  }

  If.prototype.render = function render() {
    var value = this.getValue();
    var _props = this.props,
        cond = _props.cond,
        children = _props.children;

    var parent = this.getParent();
    if (typeof cond !== 'function' || !children) {
      return null;
    }

    var canShow = cond(value);
    if (!canShow) {
      return null;
    }

    return _react.Children.only(parent.processChildren(children));
  };

  return If;
}(_Element3.default), _class.propTypes = (0, _extends3.default)({}, _Element3.default.propTypes, {
  cond: _propTypes2.default.func.isRequired,
  children: _propTypes2.default.node
}), _temp);
exports.default = If;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-form-controlled/lib/If.js
 ** module id = 1280
 ** module chunks = 0
 **/